import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';

export const useAdmin = (user) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            if (!user?.uid) {
                setIsAdmin(false);
                setLoading(false);
                return;
            }

            try {
                const adminRef = ref(database, `admins/${user.uid}`);
                const snapshot = await get(adminRef);
                const adminStatus = snapshot.exists() && snapshot.val() === true;
                setIsAdmin(adminStatus);
            } catch (error) {
                console.error('Error verificando permisos de administrador:', error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdminStatus();
    }, [user?.uid]);

    return { isAdmin, loading };
};